import { render } from "./PartnerDashboardBannerManageView.vue?vue&type=template&id=0ce18738&scoped=true"
import script from "./PartnerDashboardBannerManageView.vue?vue&type=script&lang=js"
export * from "./PartnerDashboardBannerManageView.vue?vue&type=script&lang=js"

import "./PartnerDashboardBannerManageView.vue?vue&type=style&index=0&id=0ce18738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce18738"]])

export default __exports__